<template>
  <section class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik container-options-main-container">
    <div class="w-full max-w-1024 mx-5">
      <nav
        class="flex flex-col gap-3"
        aria-label="Container solution categories"
      >
        <div class="w-full flex flex-col lg:flex-row gap-3">
          <article
            @mouseenter="hovered = 'container-sales'"
            @mouseleave="hovered = ''"
            @click="cardClick('sale')"
            class="w-full h-auto card flex flex-col justify-between cursor-pointer"
            role="button"
            tabindex="0"
            aria-label="Container sales"
          >
            <header class="text-left pl-5 pr-5 pt-5">
              <h3 class="font-bold mb-2 text-lg">Container Sales</h3>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('container-sales') }}
              </p>
            </header>
            <div
              class="container-option-card-image"
              :style="{ backgroundImage: `url(${images[0]})` }"
              aria-hidden="true"
            />
          </article>

          <div class="w-full h-auto flex flex-col gap-3">
            <article
              @mouseenter="hovered = 'refrigerated-containers'"
              @mouseleave="hovered = ''"
              @click="cardClick('refrigerate')"
              class="w-full h-1/2 card cursor-pointer"
              role="button"
              tabindex="0"
              aria-label="Refrigerated containers"
            >
              <header class="text-left p-5">
                <h3 class="font-bold mb-2 text-lg">Refrigerated Containers</h3>
                <p class="font-sm font-rubik">
                  {{ descriptionDisplay('refrigerated-containers') }}
                </p>
              </header>
            </article>

            <article
              @mouseenter="hovered = 'portable-offices'"
              @mouseleave="hovered = ''"
              @click="cardClick('office')"
              class="w-full h-1/2 card cursor-pointer"
              role="button"
              tabindex="0"
              aria-label="Portable offices"
            >
              <header class="text-left p-5">
                <h3 class="font-bold mb-2 text-lg">Portable Offices</h3>
                <p class="font-sm font-rubik">
                  {{ descriptionDisplay('portable-offices') }}
                </p>
              </header>
            </article>
          </div>
        </div>

        <div class="w-full flex flex-col lg:flex-row gap-3">
          <div class="w-full h-auto flex flex-col gap-3">
            <article
              @mouseenter="hovered = 'container-modifications'"
              @mouseleave="hovered = ''"
              @click="cardClick('modification')"
              class="w-full h-1/2 card cursor-pointer"
              role="button"
              tabindex="0"
              aria-label="Container modifications"
            >
              <header class="text-left p-5">
                <h3 class="font-bold mb-2 text-lg">Container Modifications</h3>
                <p class="font-sm font-rubik">
                  {{ descriptionDisplay('container-modifications') }}
                </p>
              </header>
            </article>

            <article
              @mouseenter="hovered = 'accessories'"
              @mouseleave="hovered = ''"
              class="w-full h-1/2 card cursor-pointer"
              role="button"
              tabindex="0"
              aria-label="Container accessories"
              @click="routingMethod('/solutions/accessories')"
            >
              <header class="text-left p-5">
                <h3 class="font-bold mb-2 text-lg">
                  Container Alliance Accessories
                </h3>
                <p class="font-sm font-rubik">
                  {{ descriptionDisplay('accessories') }}
                </p>
              </header>
            </article>
          </div>

          <article
            @mouseenter="hovered = 'container-rentals'"
            @mouseleave="hovered = ''"
            @click="cardClick('rental')"
            class="w-full h-auto card flex flex-col justify-between cursor-pointer"
            role="button"
            tabindex="0"
            aria-label="Container rentals"
          >
            <header class="text-left p-5">
              <h3 class="font-bold mb-2 text-lg">Container Rentals</h3>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('container-rentals') }}
              </p>
            </header>
            <div
              class="container-option-card-image"
              :style="{ backgroundImage: `url(${images[1]})` }"
              aria-hidden="true"
            />
          </article>
        </div>
      </nav>

      <zipcodeModal
        v-if="modalOpen"
        @close="modalOpen = false"
        :solutionSlug="solutionSlug"
      />
    </div>
  </section>
</template>

<script>
import bgImg01 from '@/images/container-options/bg-01.png'
import bgImg02 from '@/images/container-options/bg-02.png'
import ZipcodeModal from '../location-search/modal.vue'

export default {
  components: { ZipcodeModal },
  data() {
    return {
      modalOpen: false,
      solutionSlug: '',
      hovered: '',
      images: [bgImg01, bgImg02]
    }
  },
  props: { solutions: Array },
  methods: {
    routingMethod(route) {
      return (window.location.href = route)
    },
    fullDescription(slug) {
      const s = this.solutions.find((i) => i.slug === slug)
      if (s)
        return s.html_content
          .replace(/<[^>]*>?/gm, '')
          .split('&nbsp;')
          .join('')
      return ''
    },
    descriptionDisplay(slug) {
      const text = this.fullDescription(slug)
      if (this.hovered === slug) return text
      return text.length > 200 ? text.substring(0, 200) + '...' : text
    },
    cardClick(slug) {
      this.solutionSlug = slug
      this.modalOpen = true
    }
  }
}
</script>

<style scoped lang="scss">
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
.container-options-main-container {
  background-color: #0c0e20;
}
.container-options-main-text {
  padding: 48px 0px;
}
.card {
  background-color: #ffffff;
  color: #0c0e20;
  border-radius: 12px;
  border: 1px solid black;
}
.card p {
  max-height: 100px;
  overflow: hidden;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #7d7d7d;
  }
}
.card:hover p {
  overflow-y: auto;
}
.container-option-card-image {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 210px;
  border-radius: 12px;
}
@media (max-width: 1024px) {
  .container-options-main-text {
    padding: 24px 0px;
  }
}
</style>
